import Vue from 'vue';
import VueRouter from 'vue-router';

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch(err => err);
};

const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => err);
};

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    component: () => import('@/views/home/index.vue'),
    meta: {
      title: 'home',
    },
  },
  {
    path: '/error',
    component: () => import('@/views/error'),
    meta: {
      title: 'error',
    },
  },

  // 自主营销经销商
  {
    path: '/independent-marketing/agreement',
    component: () => import('@/views/independent-marketing/views/agreement'),
    meta: {
      title: 'agreement',
    },
  },
  {
    path: '/independent-marketing/apply-form',
    component: () => import('@/views/independent-marketing/views/apply-form'),
    meta: {
      title: 'apply-form',
    },
  },
  {
    path: '/independent-marketing/success',
    component: () => import('@/views/independent-marketing/views/success'),
    meta: {
      title: 'success',
    },
  },
];

const router = new VueRouter({
  mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes,
});

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token');
  if (!to.query.token && token) {
    next(`${to.fullPath}?token=${token}`);
  } else {
    next();
  }
});

export default router;
